import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import axios from "axios";
import moment from "moment";
import { queryParams } from "../../../../../utils/queryParams";

export const FETCH_CURRENT_USER_SUCCESS = "sagas/attendance/totalVisits/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "sagas/attendance/totalVisits/FETCH_FILTERS_SUCCESS";
export const FETCH_CHART_SUCCESS = "sagas/attendance/totalVisits/FETCH_CHART_SUCCESS";
export const FETCH_CURRENT_USER = "sagas/attendance/totalVisits/FETCH_CURRENT_USER";

export const RESET_FILTER_SELECTED = "sagas/attendance/totalVisits/RESET_FILTER_SELECTED";
const RESET_FILTER = "sagas/attendance/totalVisits/RESET_FILTER";

export const SET_UPDATES_LOADING = "sagas/attendance/totalVisits/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "sagas/attendance/totalVisits/SET_FILTERS_DIRTY";
export const SET_LOADING = "sagas/attendance/totalVisits/SET_LOADING";
export const SET_DATES = "sagas/attendance/totalVisits/SET_DATES";

export const UPDATE_TABLE_VIEW_SELECTED = "sagas/attendance/totalVisits/UPDATE_TABLE_VIEW_SELECTED";
export const UPDATE_CUSTOM_RANGE = "sagas/attendance/totalVisits/UPDATE_CUSTOM_RANGE";
export const UPDATE_PERIOD_TYPE = "sagas/attendance/totalVisits/UPDATE_PERIOD_TYPE";
export const UPDATE_CHART = "sagas/attendance/totalVisits/UPDATE_CHART";
export const UPDATE_DATES = "sagas/attendance/totalVisits/UPDATE_DATES";
export const UPDATE_COMPARE_DATES_SELECTED =
  "sagas/attendance/totalVisits/UPDATE_COMPARE_DATES_SELECTED";
const UPDATE_TABLE_VIEW = "sagas/attendance/totalVisits/UPDATE_TABLE_VIEW";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateData: createAction(UPDATE_CHART),
  updateDates: createAction(UPDATE_DATES),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateTableView: createAction(UPDATE_TABLE_VIEW),
  resetFilters: createAction(RESET_FILTER)
};

export default function* watchTotalVisits() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
  yield takeLatest(UPDATE_TABLE_VIEW, updateTableView);
  yield takeLatest(RESET_FILTER, resetFilters);
}

function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  yield setDates();
  try {
    yield fetchFilters();
    yield fetchChart();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* setDates() {
  const endDate = yield select((state) => state.totalVisits.currentUser.calendarEndDate);
  const startDate = moment(endDate).startOf("month").subtract(11, "months").format("YYYY-MM-DD");

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* getApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  let { startDate: start_date, endDate: end_date } = yield select(
    (state) => state.totalVisits.selectedRequestDates
  );

  return { organization_id, short_url, start_date, end_date };
}

function* fetchFilters() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  yield getTotalVisitsFilters({ organization_id, short_url });
}

function* fetchChart() {
  const commonParams = yield getApiParams();

  const { period_type, table_view } = yield select((state) => state.totalVisits.selectedFilters);

  let params = {
    ...commonParams,
    period_type: period_type.toLowerCase(),
    table_view: table_view.toString()
  };

  yield getTotalVisitsChart(params);
}

function* updateTableView({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: UPDATE_TABLE_VIEW_SELECTED, payload });
  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getTotalVisitsFilters(params) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion + "pages/attendance/total_visits_chart/filters",
      { params }
    );

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data.filters });
    yield setDates();
  } catch (err) {
    console.error(err);
  }
}

function* getTotalVisitsChart(params) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion + "pages/attendance/total_visits_chart",
      { params }
    );

    yield put({ type: FETCH_CHART_SUCCESS, payload: response.data.data });
  } catch (err) {
    console.error(err);
  }
}

function* updateCustomRange() {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
}

function* updateData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  yield setDates();

  yield put({ type: RESET_FILTER_SELECTED });

  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}
